const SECTIONS = [
  {
    id: "introduction",
    title: "Introduction",
    blocks: [
      { t: "p", x: 'Welcome to BurmeseHub.com ("BurmeseHub," "we," "us," or "our").' },
      { t: "p", x: "BurmeseHub is an online business and community directory dedicated to connecting Burmese-owned businesses, professionals, organizations, and community members throughout the United States." },
      { t: "p", x: "Our mission is to help people discover local businesses, explore services, find opportunities, and strengthen connections within the Burmese community." },
      { t: "p", x: "We respect your privacy and are committed to handling personal information responsibly and transparently." },
      { t: "p", x: "This Privacy Policy explains how we collect, use, disclose, store, and protect information when you visit www.burmesehub.com, create an account, submit a business listing, contact us, or use our services." },
    ],
  },
  {
    id: "information-we-collect",
    title: "Information We Collect",
    blocks: [
      { t: "p", x: "Depending on how you use BurmeseHub, we may collect the following categories of information." },
      { t: "h", x: "A. Personal Information" },
      { t: "p", x: "When you register, contact us, or submit information, we may collect:" },
      { t: "ul", items: ["Full name", "Email address", "Phone number", "Account login information", "City, state, or location information", "Messages, inquiries, and feedback", "Other information you voluntarily provide"] },
      { t: "h", x: "B. Business and Professional Information" },
      { t: "p", x: "When you submit or manage a business listing, we may collect:" },
      { t: "ul", items: ["Business name and description", "Business address and service area", "Business phone number and email", "Website and social media links", "Business category and services", "Business logos, photographs, and promotional images", "Business operating hours", "Information about the business owner or authorized representative"] },
      { t: "p", x: "Information included in a published business listing may be publicly accessible to visitors and search engines." },
      { t: "h", x: "C. Community Content" },
      { t: "p", x: "When available through our platform, you may submit information relating to:" },
      { t: "ul", items: ["Community organizations", "Events and announcements", "Employment opportunities", "Business promotions", "Reviews, recommendations, and feedback"] },
      { t: "p", x: "Information intended for publication may be visible to other users." },
      { t: "h", x: "D. Automatically Collected Information" },
      { t: "p", x: "When you visit our website, we and our service providers may automatically collect:" },
      { t: "ul", items: ["IP address", "Browser type", "Device information", "Pages visited", "Date and time of visits", "Referring websites", "General location derived from technical information", "Cookies and similar tracking information"] },
      { t: "p", x: "This information helps us understand how visitors use BurmeseHub and improve our services." },
    ],
  },
  {
    id: "how-we-use",
    title: "How We Use Your Information",
    blocks: [
      { t: "p", x: "We use information for legitimate business and operational purposes, including to:" },
      { t: "ul", items: ["Create, display, and manage business listings", "Connect users with businesses and community resources", "Provide and maintain website functionality", "Process business listing submissions", "Respond to customer questions and support requests", "Maintain account security", "Improve search results and user experience", "Prevent spam, fraud, and unauthorized activity", "Share community news, events, and announcements", "Communicate updates about our services", "Send promotional communications where permitted by law and applicable consent requirements", "Comply with applicable legal obligations"] },
      { t: "p", x: "We aim to collect only information reasonably necessary to operate and improve our services." },
    ],
  },
  {
    id: "public-listings",
    title: "Public Business Listings",
    blocks: [
      { t: "p", x: "BurmeseHub is a public business directory." },
      { t: "p", x: "Business information submitted for publication may be displayed on our website and made accessible through search engines." },
      { t: "p", x: "Public information may include business names, contact details, addresses, photographs, services, and descriptions." },
      { t: "p", x: "By submitting a business listing, you confirm that you have the appropriate authority to provide the information and any necessary permission to publish associated content." },
      { t: "p", x: "Business owners may request corrections, updates, or removal of their listings by contacting BurmeseHub." },
      { t: "p", x: "Please avoid submitting sensitive personal information or private contact details that you do not wish to make publicly available." },
      { t: "p", x: "Information already indexed, saved, or copied by third parties may remain accessible outside our control after a listing is removed." },
    ],
  },
  {
    id: "account-security",
    title: "Account Registration and Security",
    blocks: [
      { t: "p", x: "If you create an account on BurmeseHub, we may use your registration information to provide account access and manage your submitted listings or other content." },
      { t: "p", x: "You are responsible for maintaining the confidentiality of your login credentials and notifying us of suspected unauthorized account activity." },
      { t: "p", x: "We take reasonable steps to protect account information but cannot guarantee that any online system is completely secure." },
    ],
  },
  {
    id: "cookies",
    title: "Cookies and Website Analytics",
    blocks: [
      { t: "p", x: "BurmeseHub may use cookies and similar technologies to improve website performance, maintain sessions, remember preferences, analyze traffic, and understand how visitors interact with our platform." },
      { t: "p", x: "Some cookies may be necessary for the website to function properly. Other technologies may be provided by analytics or advertising partners, where enabled." },
      { t: "p", x: "You can manage certain cookie preferences through your browser or through any consent controls made available on our website." },
      { t: "p", x: "Disabling some cookies may affect website functionality." },
    ],
  },
  {
    id: "sharing",
    title: "How We Share Information",
    blocks: [
      { t: "p", x: "We may disclose information in the following circumstances:" },
      { t: "ul", items: ["Public Directory Listings: Business information submitted for public display is available to website visitors.", "Service Providers: We may work with trusted companies that provide website hosting, cloud storage, email delivery, analytics, security, or technical support.", "Legal Requirements: We may disclose information when reasonably necessary to comply with legal obligations, respond to lawful requests, protect our rights, or prevent fraud and misuse.", "Business Transfers: Information may be transferred as part of a merger, acquisition, restructuring, or sale of business assets, subject to applicable law.", "With Your Direction: We may disclose information when you request or authorize us to do so."] },
      { t: "p", x: "We do not authorize service providers to use personal information for unrelated purposes merely because they provide services to us." },
      { t: "p", x: "Any practices involving the sale or sharing of personal information for targeted advertising will be disclosed and accompanied by legally required choices, where applicable." },
    ],
  },
  {
    id: "email-marketing",
    title: "Email Communications and Marketing",
    blocks: [
      { t: "p", x: "We may send account-related notifications, listing updates, important service announcements, or responses to inquiries." },
      { t: "p", x: "If you subscribe to promotional communications, we may also send business highlights, community announcements, newsletters, or special offers." },
      { t: "p", x: "You may opt out of promotional emails using the unsubscribe link included in those messages or by contacting us." },
      { t: "p", x: "Unsubscribing from marketing does not prevent us from sending necessary account, security, or service-related communications." },
      { t: "p", x: "We will obtain any consent required by applicable law before sending marketing text messages." },
    ],
  },
  {
    id: "third-party",
    title: "Third-Party Websites and Services",
    blocks: [
      { t: "p", x: "BurmeseHub may contain links to third-party websites, business pages, social media accounts, and external services." },
      { t: "p", x: "We are not responsible for the privacy practices, content, or security of independently operated third-party websites." },
      { t: "p", x: "We encourage users to review the privacy policies of those services before providing personal information." },
    ],
  },
  {
    id: "data-security",
    title: "Data Security",
    blocks: [
      { t: "p", x: "We use reasonable administrative, technical, and organizational safeguards designed to protect personal information against unauthorized access, alteration, disclosure, or destruction." },
      { t: "p", x: "Access to information may be limited to authorized personnel and service providers who need it for legitimate operational purposes." },
      { t: "p", x: "Although we make reasonable efforts to protect information, no method of internet transmission or electronic storage is completely secure." },
    ],
  },
  {
    id: "data-retention",
    title: "Data Retention",
    blocks: [
      { t: "p", x: "We retain personal information only for as long as reasonably necessary to fulfill the purposes described in this policy." },
      { t: "p", x: "Retention periods depend on factors such as:" },
      { t: "ul", items: ["Whether your account remains active", "Whether a business listing remains published", "Operational and security requirements", "Applicable legal obligations", "The nature of any customer support requests or disputes"] },
      { t: "p", x: "You may request account deletion or removal of personal information, subject to applicable legal and operational exceptions." },
    ],
  },
  {
    id: "privacy-rights",
    title: "Your Privacy Rights",
    blocks: [
      { t: "p", x: "Depending on where you reside and applicable privacy laws, you may have rights concerning your personal information, including:" },
      { t: "ul", items: ["Access: Request information about personal data we maintain about you.", "Correction: Request correction of inaccurate personal information.", "Deletion: Request deletion of eligible personal information.", "Opt-Out: Opt out of certain marketing or data-sharing activities where applicable.", "Consent Withdrawal: Withdraw previously provided consent, where applicable.", "Business Listing Management: Request updates or removal of your business information.", "Appeal: Appeal certain privacy-request decisions where required by applicable law."] },
      { t: "p", x: "We will review and respond to verified requests within applicable legal timeframes." },
      { t: "p", x: "Where required by law, we will not discriminate against users for exercising their privacy rights." },
      { t: "p", x: "To submit a privacy request, please contact us using the information provided below." },
    ],
  },
  {
    id: "california-rights",
    title: "Privacy Rights for California and Other U.S. Residents",
    blocks: [
      { t: "p", x: "Residents of California and certain other U.S. states may have additional privacy rights under applicable laws." },
      { t: "p", x: "Where such laws apply to BurmeseHub, we will honor legally required requests to access, correct, delete, or obtain information concerning personal data, and to opt out of qualifying sales, sharing, or targeted advertising." },
      { t: "p", x: "Additional disclosures or privacy controls will be provided where required." },
    ],
  },
  {
    id: "childrens-privacy",
    title: "Children's Privacy",
    blocks: [
      { t: "p", x: "BurmeseHub is intended for a general audience and is not directed toward children under the age of 13." },
      { t: "p", x: "We do not knowingly collect personal information from children under 13." },
      { t: "p", x: "If we become aware that we have collected such information without the appropriate authorization, we will take reasonable steps to delete it." },
      { t: "p", x: "Parents or guardians may contact us with related concerns." },
    ],
  },
  {
    id: "international",
    title: "International Visitors",
    blocks: [
      { t: "p", x: "BurmeseHub primarily serves businesses and communities within the United States." },
      { t: "p", x: "If you access our website from another country, your information may be processed and stored in the United States or other locations where our service providers operate." },
      { t: "p", x: "Privacy protections may differ between jurisdictions, and we will comply with applicable requirements governing international personal data processing and transfers." },
    ],
  },
  {
    id: "changes",
    title: "Changes to This Privacy Policy",
    blocks: [
      { t: "p", x: "We may update this Privacy Policy periodically to reflect changes to our services, technology, business practices, or legal requirements." },
      { t: "p", x: "When changes are made, we will revise the effective date at the top of this page." },
      { t: "p", x: "Material changes will be communicated through appropriate channels when required by applicable law." },
      { t: "p", x: "We encourage users to review this page periodically." },
    ],
  },
];

export default SECTIONS;
